export const EVENTS = {
  scheduleDemoClick: 'Schedule Demo Click',
  demoBooked: 'Demo Booked',
  demoLinkClick: 'Demo Link Click',
  demoLanding: 'Demo Landing',
  signupLinkClick: 'Signup Link Click',
  waitlistSubmit: 'Waitlist Submit',
  waitlistSuccess: 'Waitlist Success',
  waitlistFailure: 'Waitlist Failure',
  signupStarted: 'Signup Started',
  signupCompleted: 'Signup Completed',
} as const;

export type EventName = (typeof EVENTS)[keyof typeof EVENTS];
type Props = Record<string, string | number | boolean>;

/** Fire a Plausible custom event. Fire-and-forget: no-ops if the script is absent. */
export function track(event: EventName, props?: Props): void {
  const hasProps = props && Object.keys(props).length > 0;
  window.plausible?.(event, hasProps ? { props } : undefined);
}
